import Head from 'next/head';
import { NextPage } from 'next';

import {
  Nullable,
  SignupDetails,
  WidgetListItem,
} from '@/core/interfaces/common';
import { wrapper } from '@/core/store/store';

import { WidgetList } from '@/features/WidgetList';

import { request } from '@/utils/request';

interface WidgetListProps {
  widgetList: Array<WidgetListItem>;
  useName: boolean;
}

const WidgetListPage: NextPage<WidgetListProps> = (initialProps: WidgetListProps) => {
  const {
    widgetList, useName,
  } = initialProps;

  return (
    <>
      <Head>
        <title key="title">Action Centers</title>
        <meta
          property="og:title"
          content="Action Centers"
        />
      </Head>
      <WidgetList
        widgetList={widgetList}
        useName={useName}
      />
    </>
  );
};

WidgetListPage.getInitialProps = wrapper.getInitialPageProps(() => async ({
  query,
  res,
}) => {
  const widgetList = await request
    .get<Nullable<SignupDetails>>(`public/act/all/${query.uuid}/`)
    .then(({ data }) => data)
    .catch(error => null);

  if (res && !widgetList) {
    res.statusCode = 404;
  }

  return {
    useName: query.useName !== undefined,
    widgetList,
  };
});

export default WidgetListPage;
